/** remove everything but digits */
function clean(value = '') {
	return value.replace(/\D+/g, '');
}

export default clean;
